import React from "react";
import { withTranslation } from "react-i18next";
import { Panel } from "components/bootstrap";
import HelpPanel from "components/event-definitions/common/HelpPanel";
import commonStyles from "./commonStyles.css";
class CorrelationPreview extends React.Component {
  constructor() {
    super(...arguments);
    this.renderRule = (rule) => {
      const { eventDefinitions, t } = this.props;
      const eventDefinition = eventDefinitions.find((d) => d.id === rule.event_creator_equals) || {};
      const title = rule.event_creator_equals ? eventDefinition.title : t("correlation_preview.no_event_assigned");
      return /* @__PURE__ */ React.createElement("li", { key: rule.id }, title || t("correlation_preview.event_definition_not_available"));
    };
  }
  render() {
    const { rules, t } = this.props;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HelpPanel, { collapsible: true, title: t("correlation_preview.help_title") }, /* @__PURE__ */ React.createElement("p", null, t("correlation_preview.help_text"))), /* @__PURE__ */ React.createElement(Panel, { className: commonStyles.preview, header: /* @__PURE__ */ React.createElement("h3", null, t("correlation_preview.title")) }, /* @__PURE__ */ React.createElement("p", null, t("correlation_preview.description")), rules.length === 0 ? /* @__PURE__ */ React.createElement("p", null, t("correlation_preview.no_rules")) : /* @__PURE__ */ React.createElement("ol", { className: commonStyles.previewList }, rules.map(this.renderRule))));
  }
}
export default withTranslation("enterprise_security")(CorrelationPreview);
